export default {
    FETCH_BUYER_PLATFORM: "FETCH_BUYER_PLATFORM",
    ADD_UPDATE_SUB_MERCHANT: "ADD_UPDATE_SUB_MERCHANT",
    GET_SUB_MERCHANT: "GET_SUB_MERCHANT",
    UPLOAD_MORE_ATTACHMENT: "UPLOAD_MORE_ATTACHMENT",
    DELETE_MORE_ATTACHMENT: "DELETE_MORE_ATTACHMENT",
    FETCH_BUYER_PLATFORM_DETAILS: "FETCH_BUYER_PLATFORM_DETAILS"
}